'use client';

/**
 * Floating orb that opens the AI assistant panel.
 *
 * Hidden while the panel is open. On mobile it sits to the right of the
 * bottom navigation menu (h-16 at bottom-4 → vertically centered with it);
 * on desktop it sits in the bottom-right corner.
 */

import { useAiAssistant } from '@/lib/platform/contexts/ai-assistant-context';
import { SparklesIcon } from '@heroicons/react/24/solid';

export default function AiOrb() {
  const { isOpen, open } = useAiAssistant();

  if (isOpen) return null;

  return (
    <button
      type="button"
      onClick={open}
      aria-label="Open AI assistant"
      className="fixed right-2 bottom-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-600 text-white shadow-lg transition-transform hover:scale-105 hover:bg-indigo-500 md:right-6 md:bottom-6 print:hidden"
    >
      <SparklesIcon className="h-6 w-6" />
    </button>
  );
}
